import React, { useState, useEffect } from 'react';
import { Accordion, Card, OverlayTrigger, Spinner } from 'react-bootstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Loader from '../../../Components/Utility/Loader/Loader';
import BtnAdd from '../../../Components/Utility/FilterAction/BtnAdd';
import CardDrag from './CardDrag';
import { useComponent } from '../../UserSetting/UsersLibrary/UserRights';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';

function SampleStatus({
  addSampleStatus,
  ssmBtnDisable,
  isSSUnique,
  renderTooltipOpenClosePsm,
  callApi,
  buttonDownSsm,
  btnCall,
  showSSM,
  isLoadingSSM,
  sampleStatusData,
  handleCheckboxST,
  handleChanged,
  renderTooltipActiveInactive,
  activeInactiveClicked,
  renderTooltipDelete,
  handleDelete,
  saveSampleStatus,
  isSSM,
  handleSampleStatus,
  isUniqueId,
  OpenReArrangeFunction,
}) {
  const [scrollEl, setScrollEl] = useState();
  const { t } = useTranslation('common');
  const [cards, setCards] = useState([]);
  const reducer = useSelector((estate) => estate);
  const {
    Users: { logInRights },
  } = reducer;
  const { CheckActionPermission } = useComponent();
  const [userRights, setUserRights] = useState({});
  useEffect(() => {
    if (logInRights) {
      setUserRights(logInRights);
    }
  }, [logInRights]);
  const MasterAddEditAccess = CheckActionPermission(userRights, 'masters', 'samples', 'addEdit');
  const MasterDeleteAccess = CheckActionPermission(userRights, 'masters', 'samples', 'delete');
  useEffect(() => {
    if (Array.isArray(sampleStatusData) && sampleStatusData.length) {
      const item = [...sampleStatusData];
      setCards(item);
    }
  }, [sampleStatusData]);

  const renderCard = (card, index) => {
    return (
      <CardDrag
        index={index}
        item={card}
        handleCheckboxST={handleCheckboxST}
        handleChanged={handleChanged}
        renderTooltipActiveInactive={renderTooltipActiveInactive}
        activeInactiveClicked={activeInactiveClicked}
        renderTooltipDelete={renderTooltipDelete}
        handleDelete={handleDelete}
        handleSampleStatus={handleSampleStatus}
        isSSUnique={isSSUnique}
        isUniqueId={isUniqueId}
        masterAddEditAccess={MasterAddEditAccess}
        masterDeleteAccess={MasterDeleteAccess}
      />
    );
  };

  useEffect(() => {
    if (scrollEl) {
      scrollEl.scrollTop = 1000;
    }
  }, [scrollEl]);
  return (
    <Accordion className="mb-4 master-accordian">
      <Card>
        <Card.Header>
          <div className="title-container">
            <p>{t('SAMPLE_STATUS.SAMPLE_STATUS_MASTER')}</p>
          </div>
          <div className={!MasterAddEditAccess ? 'action-title-btns single-btn' : 'action-title-btns'}>
            {MasterAddEditAccess && (
              <button
                type="button"
                onClick={() => OpenReArrangeFunction('sampleStatus')}
                className="filter-btn filter-button_add"
                disabled={ssmBtnDisable || !isSSUnique}
                aria-label={t('SAMPLE_STATUS.REARRANGE')}
                title={t('SAMPLE_STATUS.REARRANGE')}
              >
                <span className="icon-expand" />
              </button>
            )}
            <BtnAdd onBtnClick={addSampleStatus} forDisable={ssmBtnDisable || !isSSUnique} addEditAccess={MasterAddEditAccess} />
            <OverlayTrigger placement="auto" delay={{ show: 250, hide: 400 }} overlay={renderTooltipOpenClosePsm}>
              <button onClick={() => callApi('sampleStatusMaster')} type="button">
                {btnCall(buttonDownSsm)}
              </button>
            </OverlayTrigger>
          </div>
        </Card.Header>
        {showSSM &&
          (isLoadingSSM ? (
            <Loader />
          ) : (
            <Card.Body>
              <PerfectScrollbar
                containerRef={(ref) => {
                  setScrollEl(ref);
                }}
              >
                <ul>{cards?.map((sTEle, sTIndex) => renderCard(sTEle, sTIndex))}</ul>
              </PerfectScrollbar>
              {MasterAddEditAccess && (
                <div className="section-save">
                  <CustomTooltip tooltipText={t('common:COMMON_LABEL.SAVE')}>
                    <button
                      aria-label="Save"
                      className="btn btn-page-filter btn-white"
                      onClick={saveSampleStatus}
                      disabled={ssmBtnDisable || !isSSUnique}
                      type="button"
                    >
                      {isSSM ? (
                        <Spinner animation="border" />
                      ) : (
                        <>
                          <span className="icon-Save c-button-align f-20 mr-2" /> {t('SAMPLE_STATUS.SAVE')}
                        </>
                      )}
                    </button>
                  </CustomTooltip>
                </div>
              )}
            </Card.Body>
          ))}
      </Card>
    </Accordion>
  );
}

export default SampleStatus;
